/* istanbul ignore file */
import React, { ReactElement } from "react";
import { useChapter } from "../../../contexts/chapter-context";
import { Chapter } from "../components/Chapter";

export const Bijlagen = (): ReactElement => {
  const chapter = useChapter();
  chapter.startAttachments();

  return (
    <>
      <Chapter></Chapter>
    </>
  );
};

export default Bijlagen;